import { Switch, Route } from 'react-router-dom';
import {
  FLIGHTS_RESERVE,
  FLIGHTS_SEARCH,
  PAYMENTS_FLIGHTS,
  FLIGHTS_RESERVE_SUCCESSFUL,
  DEFAULT,
} from '@shared/helpers/routes';

import FlightsSearch from '@shared/pages/Flights/FlightsSearch';
import LayoutPaymentGateway from '@shared/pages/Flights/LayoutPaymentGateway';
import FlightsReserve from '@shared/pages/Flights/FlightsReserve';
import PaymentStarlings from '@shared/pages/Flights/Payments';
import ReserveSuccess from '@shared/pages/Flights/Success';
import NotFoundPage from '@shared/pages/NotFoundPage';

export default () => {
  return (
    <Switch>
      <Route exact path={FLIGHTS_SEARCH}>
        <FlightsSearch />
      </Route>

      <Route exact path={PAYMENTS_FLIGHTS}>
        <LayoutPaymentGateway>
          <PaymentStarlings />
        </LayoutPaymentGateway>
      </Route>

      <Route exact path={FLIGHTS_RESERVE}>
        <LayoutPaymentGateway>
          <FlightsReserve />
        </LayoutPaymentGateway>
      </Route>

      <Route exact path={FLIGHTS_RESERVE_SUCCESSFUL}>
        <ReserveSuccess />
      </Route>

      <Route path={DEFAULT}>
        <NotFoundPage />
      </Route>
    </Switch>
  );
};
